import BossModel from "@/models/BossModel";

export default class WidgetTemplate extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/templates';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetTemplates';

    static primaryKey = 'key';

    static fields() {
        return {
            description: this.attr(null),
            isFillable: this.boolean(null),
            isPlaceable: this.boolean(null),
            key: this.attr(null),
            maxWidthPercentage: this.number(null),
            minWidthPercentage: this.number(null),
            model_name: this.attr(null),
            name: this.attr(null),
        };
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getAll(term = '') {
        if (term.length > 0) {
            let match = new RegExp(term, "gi");
            return this.all().filter(item => item.name.match(match) || item.description.match(match));
        }
        return this.all();
    }

    static getPlaceables() {
        return this.query().where('isPlaceable',true).get();
    }

    /**
     *
     * @param modelName
     * @returns {*}
     */
    static byModelName(modelName) {
        return this.all().find(item => item.model_name === modelName);
    }

    /**
     *
     * @param key
     * @returns {*}
     */
    static byKey(key) {
        return this.all().find(item => item.key === key);
    }

    /**
     *
     * @param column
     * @returns {boolean|boolean}
     * @constructor
     */
    FitsInColumn(column) {
        let boxWidth = column.ActualWidthPercentage();

        return this.minWidthPercentage <= boxWidth && this.maxWidthPercentage >= boxWidth;
    }

    icon(){
        switch (this.model_name){
            case 'Gallery': return 'mdi-view-gallery-outline';
            case 'Title': return 'mdi-alpha-t';
            case 'Information': return 'mdi-image-text';
            case 'PhotoButton': return 'mdi-card-outline';
            case 'Accordion': return 'mdi-format-list-bulleted';
            case 'PhotoSlider': return 'mdi-image-multiple';
            case 'CategoryShortcut': return 'mdi-image-multiple';
            case 'ProductBlock': return 'mdi-package-variant-closed';
            case 'ProductSearchForm': return 'mdi-card-search-outline';
            case 'CountryInformation': return 'mdi-bullhorn-outline';
            case 'LegalContent': return 'mdi-script-text-outline';
            case 'ContactBlock': return 'mdi-card-account-phone-outline';
            case 'MagazineRequest': return 'mdi-newspaper';
            case 'Blog': return 'mdi-post-outline';
            case 'ExpertiseUser': return 'mdi-account-details-outline';
            case 'ContactRequest': return 'mdi-phone';
            case 'CustomerReview': return 'mdi-message-text-outline';
            case 'FeaturedArticle': return 'mdi-newspaper-variant-multiple';
            default:
                console.warn(this.model_name + 'icon is not defined');
                return 'mdi-skull-crossbones'
        }
    }
}
